// styled-components.ts
import styled, { ThemeProvider, css, keyframes } from 'styled-components';

export { css, keyframes, ThemeProvider };
export default styled;
